import React, { useState } from "react";
import {
  Box,
  Divider,
  Paper,
  Stack,
  Tab,
  Tabs,
  Typography,
} from "@mui/material";
import AssignmentTurnedInOutlinedIcon from "@mui/icons-material/AssignmentTurnedInOutlined";
import CalendarMonthOutlinedIcon from "@mui/icons-material/CalendarMonthOutlined";

import Timesheets from "../../Timesheets";
import TimesheetSummary from "../../TimesheetSummary";

const tabs = [
  {
    key: "tracker",
    label: "Work tracker",
    icon: <AssignmentTurnedInOutlinedIcon fontSize="small" />,
  },
  {
    key: "calendar",
    label: "Timesheets",
    icon: <CalendarMonthOutlinedIcon fontSize="small" />,
  },
];

const WorkSection = () => {
  const [activeTab, setActiveTab] = useState("tracker");

  return (
    <Paper variant="outlined" sx={{ borderRadius: 2, overflow: "hidden" }}>
      <Stack
        direction={{ xs: "column", sm: "row" }}
        spacing={2}
        alignItems={{ xs: "flex-start", sm: "center" }}
        justifyContent="space-between"
        sx={{ p: 2.5 }}
      >
        <Stack direction="row" spacing={1.5} alignItems="center">
          <Box>
            <Typography variant="h5" sx={{ fontWeight: 850, lineHeight: 1.2 }}>
              Work
            </Typography>
            <Typography variant="body2" color="text.secondary">
              Submit work logs, monitor approvals, and review monthly timesheets.
            </Typography>
          </Box>
        </Stack>
      </Stack>

      <Divider />

      <Tabs
        value={activeTab}
        onChange={(_event, nextValue) => setActiveTab(nextValue)}
        variant="scrollable"
        scrollButtons="auto"
        sx={{
          px: 2.5,
          minHeight: 48,
          "& .MuiTab-root": {
            minHeight: 48,
            textTransform: "none",
            fontWeight: 800,
          },
        }}
      >
        {tabs.map((tab) => (
          <Tab
            key={tab.key}
            value={tab.key}
            icon={tab.icon}
            iconPosition="start"
            label={tab.label}
          />
        ))}
      </Tabs>

      <Divider />

      <Box>
        {activeTab === "tracker" ? <TimesheetSummary /> : <Timesheets />}
      </Box>
    </Paper>
  );
};

export default WorkSection;
